import { featureKeyEnum, useGetMyFeatureAccess } from "~/gen/api"

export const useHasAgecComplianceFeatureAccess = () => {
  const { data: myFeatureAccessData } = useGetMyFeatureAccess(
    featureKeyEnum["agec-compliance"]
  )
  return myFeatureAccessData?.data?.hasAccess ?? false
}
